import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const ITGoodsInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="IT Goods"
    sectionDisplayName="IT Goods"
    backRoute="/sections/it-goods"
  />
);

export default ITGoodsInwardConsignment;
